module.exports = __webpack_public_path__ + "img/js7.fae3066f.jpg";